import { resolvePublicUploadsUrl } from './resolvePublicUploadsUrl';

/**
 * Resolve image field values for browser <img src>.
 * Uses the app (frontend) origin; /uploads is proxied to the backend.
 */
export function resolveImageSrc(value) {
  return resolvePublicUploadsUrl(value);
}
